import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { pageContext } from 'ctm-util-functions';
import { SimpleFlexbox } from '../flexbox/flexbox';
import { InternalLink } from '../internal_link/internal_link';

/**
 * Specific button to take user back to start page, then run onMountApi for start page
 */
class StartOverButton extends PureComponent {

    constructor(props) {
        super(props);

        // store a local reference to the page schema model
        this.pageSchemaModel = pageContext.getProps().models.pageSchemaModel;
    }

    /**
     * onClick event handler that redirects user to start page
     * @note We have to dispatch this action here so it also runs the onMountApi of start page so we have transaction data
     */
    onClick = () => {
        const { dispatch } = this.props;

        // clear current error before redirect (close the error modal)
        dispatch({ type: 'CLEAR_CURRENT_ERROR' });

        // Progress to start page, run its onMount API calls
        dispatch({
            type: 'PROGRESS_TO_PAGE',
            pageName: 'start',
            // optional, if not passed in the action, saga will get from the pageContext
            pageSchemaModel: this.pageSchemaModel
        });
    };

    /**
     * Renders a internalLink component to redirect user back to journey/start
     * @returns {Node} - a internalLink component within a Flexbox component
     */
    render = () => {
        return (
            <SimpleFlexbox display="flex" contentCenter="xs">
                <InternalLink
                    data-id="error_redirect_start"
                    href={`${this.pageSchemaModel.getJourneyBasePageName()}/journey/start`}
                    label="Start a new quote"
                    UIComponent="btn_secondary_xlarge_semi_rounded"
                    onClick={this.onClick}
                />
            </SimpleFlexbox>
        );
    };

}

StartOverButton.propTypes = {
    dispatch: PropTypes.func.isRequired
};

export { StartOverButton };
